/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdditionalDriverInvitationPrebooking } from './AdditionalDriverInvitationPrebooking';
import {
    AdditionalDriverInvitationPrebookingFromJSON,
    AdditionalDriverInvitationPrebookingFromJSONTyped,
    AdditionalDriverInvitationPrebookingToJSON,
} from './AdditionalDriverInvitationPrebooking';
import type { DriverPermissionCheckResultDto } from './DriverPermissionCheckResultDto';
import {
    DriverPermissionCheckResultDtoFromJSON,
    DriverPermissionCheckResultDtoFromJSONTyped,
    DriverPermissionCheckResultDtoToJSON,
} from './DriverPermissionCheckResultDto';

/**
 * 
 * @export
 * @interface AdditionalDriverInvitationRto
 */
export interface AdditionalDriverInvitationRto {
    /**
     * 
     * @type {AdditionalDriverInvitationPrebooking}
     * @memberof AdditionalDriverInvitationRto
     */
    prebooking: AdditionalDriverInvitationPrebooking;
    /**
     * 
     * @type {DriverPermissionCheckResultDto}
     * @memberof AdditionalDriverInvitationRto
     */
    userValidationResult: DriverPermissionCheckResultDto;
    /**
     * 
     * @type {string}
     * @memberof AdditionalDriverInvitationRto
     */
    additionalDriverFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalDriverInvitationRto
     */
    additionalDriverLastName: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdditionalDriverInvitationRto
     */
    isLinkAccepted: boolean;
}

/**
 * Check if a given object implements the AdditionalDriverInvitationRto interface.
 */
export function instanceOfAdditionalDriverInvitationRto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "prebooking" in value;
    isInstance = isInstance && "userValidationResult" in value;
    isInstance = isInstance && "additionalDriverFirstName" in value;
    isInstance = isInstance && "additionalDriverLastName" in value;
    isInstance = isInstance && "isLinkAccepted" in value;

    return isInstance;
}

export function AdditionalDriverInvitationRtoFromJSON(json: any): AdditionalDriverInvitationRto {
    return AdditionalDriverInvitationRtoFromJSONTyped(json, false);
}

export function AdditionalDriverInvitationRtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalDriverInvitationRto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prebooking': AdditionalDriverInvitationPrebookingFromJSON(json['prebooking']),
        'userValidationResult': DriverPermissionCheckResultDtoFromJSON(json['userValidationResult']),
        'additionalDriverFirstName': json['additionalDriverFirstName'],
        'additionalDriverLastName': json['additionalDriverLastName'],
        'isLinkAccepted': json['isLinkAccepted'],
    };
}

export function AdditionalDriverInvitationRtoToJSON(value?: AdditionalDriverInvitationRto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prebooking': AdditionalDriverInvitationPrebookingToJSON(value.prebooking),
        'userValidationResult': DriverPermissionCheckResultDtoToJSON(value.userValidationResult),
        'additionalDriverFirstName': value.additionalDriverFirstName,
        'additionalDriverLastName': value.additionalDriverLastName,
        'isLinkAccepted': value.isLinkAccepted,
    };
}

